import { defineMessages } from 'react-intl';

export default defineMessages({
  noProjectOptionsText: {
    id: 'frontbucket.profile.repositories.filter.projects.noProjectOptions',
    description:
      'Descriptive text of empty select state if search results returned no results',
    defaultMessage: 'No projects found',
  },
  noSearchResultsText: {
    id: 'frontbucket.profile.repositories.filter.projects.noSearchResults',
    description:
      'Descriptive text of empty select state if default projects are not found',
    defaultMessage: 'No results',
  },
  errorText: {
    id: 'frontbucket.profile.repositories.filter.projects.error',
    description:
      'Descriptive text of empty select state if project request fails',
    defaultMessage: 'Unable to fetch projects',
  },
  projectSearchPlaceholder: {
    id: 'frontbucket.profile.repositories.filter.projects.placeholder',
    description: 'Descriptive placeholder text for select component',
    defaultMessage: 'Projects',
  },
});
